export default {
      id: "dzen-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#dzen",
      toString: function () {
        return this.url;
      }
    }